import * as actionTypes from '../constants/actionTypes';

export const invoiceDataLoaded = (invoiceData: object) => (dispatch: any) => dispatch({
  type: actionTypes.INVOICE_DATA_LOADED,
  payload: {
    invoiceData,
  },
});

export default invoiceDataLoaded;
